<div class="task-gantt-container">
  <div class="gantt-wrapper">
    <!-- Loading Overlay -->
    @if (loading) {
      <div class="gantt-loading-overlay">
        <div class="loading-content">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Loading tasks...</p>
        </div>
      </div>
    }

    <div class="gantt-nav">
      <button type="button" class="gantt-nav-btn" (click)="goPrev10Days()" [disabled]="loading" title="Previous 10 days">
        <i class="pi pi-chevron-left"></i>
        <span>Prev 10 days</span>
      </button>
      <span class="gantt-nav-label">{{ viewRangeLabel }}</span>
      <button type="button" class="gantt-nav-btn" (click)="goNext10Days()" [disabled]="loading" title="Next 10 days">
        <span>Next 10 days</span>
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>

    <div class="gantt-content">
      <div class="gantt-header">
        <div class="gantt-sidebar-header">Task</div>
        <div class="gantt-timeline">
          @for (day of days; track day) {
            <div class="timeline-day">
              <div class="day-month">{{ day.format('MMM') }}</div>
              <div class="day-label">{{ day.format('D') }}</div>
              <div class="day-name">{{ day.format('ddd') }}</div>
            </div>
          }
        </div>
      </div>

      <div class="gantt-body">
        @for (ganttTask of ganttTasks; track ganttTask) {
          <div class="gantt-row"
            [class.subtask-row]="isSubTask(ganttTask.task)">
            <div class="gantt-sidebar">
              <div class="task-info"
                (click)="onTaskClick(ganttTask.task, $event)"
                (dblclick)="onTaskDoubleClick(ganttTask.task, $event)"
                (contextmenu)="openCm($event, gf, ganttTask.task)">
                <div class="d-flex gap-2">
                  <div>
                    <span (click)="openCm($event, gf, ganttTask.task)"><i class="pi pi-align-justify" aria-hidden="true"
                    style="margin-left: 5px"></i></span>
                  </div>
                  <div class="task-id">
                    @if (isSubTask(ganttTask.task)) {
                      <i class="pi pi-sitemap subtask-icon" title="Sub-task"></i>
                    }
                    #{{ ganttTask.task.taskId }}
                  </div>
                </div>
                <span class="task-name">{{ ganttTask.task.name }}</span>
                @if (isSubTask(ganttTask.task) && getParentTaskDisplayName(ganttTask.task)) {
                  <span class="parent-task-indicator clickable"
                    (click)="onParentTaskClick(ganttTask.task, $event)"
                    [title]="'Click to open parent task'">
                    <i class="pi pi-arrow-up"></i>
                    {{ getParentTaskDisplayName(ganttTask.task) }}
                  </span>
                }
              </div>
            </div>
            <div class="gantt-chart" [style.--gantt-days]="days.length">
              <div class="gantt-bar"
                [class.subtask-bar]="isSubTask(ganttTask.task)"
                [style.left.%]="getTaskPosition(ganttTask)"
                [style.width.%]="getTaskWidth(ganttTask)"
                (click)="onTaskClick(ganttTask.task, $event)"
                (dblclick)="onTaskDoubleClick(ganttTask.task, $event)"
                (contextmenu)="openCm($event, gf, ganttTask.task)">
                <span class="bar-label">{{ ganttTask.task.name }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Empty State -->
    @if (!loading && ganttTasks.length === 0) {
      <div class="gantt-empty-state">
        <i class="pi pi-inbox"></i>
        <p>No tasks found</p>
      </div>
    }
  </div>
  <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
</div>

<p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
  @if (taskApiData) {
    <app-task-summary [task]="taskApiData"></app-task-summary>
  }
</p-dialog>

